import {
  MIN_FILENAME_LENGTH,
  MAX_FILENAME_LENGTH,
  MAX_FILE_SIZE,
} from 'globals/constants';

const GlobalText = {
  // GeneralEditableForm
  name: 'Name',
  email: 'Email',
  matric: 'Matric No.',
  honorific: 'Honorific',
  lecturerID: 'Lecturer ID',
  coordinator: 'Coordinator',

  // isSupervisorVisible: "Allow student to view project's supervisor name ?",
  academicSession: 'Academic Session',
  code: 'Code',
  category: 'Category',
  subCategory: 'Sub Category',

  projectCategories: 'Project Categories',
  // CoordinatorMainConfigForm
  isSupervisorVisible: 'Visibility of project supervisor',
  isProjectVisibleToOtherLecturers: 'Visibility of project by other lecturers',
  isCurr: 'Set as current academic session ?',
  supervisorTitleQuota: 'Supervisor Title Quota',
  lecturerQuota: 'Lecturer Quota',
  bidQuota: 'Student Bidding Quota',
  bidRoundCount: 'No. of Bidding Round',
  titleSubmissionRoundDates: 'Title Submission Round Date Range',

  projectStages: 'Project Stages',

  // CoordinatorAddExaminerForm
  examiner1: 'Examiner 1',
  examiner2: 'Examiner 2',

  // Student
  title: 'Title',
  supervisor: 'Supervisor',
  status: 'Project Status',
  description: 'Project Description',
  requirement: 'Skills Required',
  version: 'Version',
  photo: 'Photo',
  cgpa: 'CGPA',
  muet: 'MUET',
  skills: 'Skills',
  introduction: 'Introduction / Internship Experience',
  comments: 'Comments',
  major: 'Major',
  state: 'Status',

  // Lecturer
  phone: 'Phone',

  subcategory: 'Subcategory',
  difficulty: 'Difficulty',
  language: 'Language',
  application: 'Application',
  operatingSystem: 'Operating System',
  programmingLanguage: 'Programming Language',
  technology: 'Technology',

  additionalRequirements: 'Additional Requirements',

  // Error

  duplicateAcademicSessionError:
    'Sorry, this academic session is existed, please insert another academic session.',

  emptyFileError: 'Sorry, the file must not be empty',
  exceededMaxFileSizeError: `Sorry, the maximum file size allowed is ${MAX_FILE_SIZE /
    1024 /
    1024} MB`,

  filenameLengthError: `Sorry, the name of the file should contain ${MIN_FILENAME_LENGTH} - ${MAX_FILENAME_LENGTH} characters`,

  internetConnectionError:
    'Sorry, please check your internet connection and try again',

  invalidValueError: 'Sorry, you have entered an invalid value',

  invalidEmailError: 'Please enter a valid email address',
  invalidPasswordError:
    'Please enter a valid password (8 - 30 characters with at least one alphabet, one number and one special character)',
  invalidLecturerIDError: 'Sorry, lecturer ID must be alphanumeric or N/A',
  invalidRegistrationNumberError:
    'Sorry, registration number must be alphanumeric',
  invalidUrlError:
    'Please enter a valid URL (e.g. "https://www.example.com/page")',

  requiredError: '* Required',

  tryAgainError: 'Sorry, some unexpected error occurred, please try again!',

  unauthorizedError: 'Sorry, you are not authorized to access this page',

  // Message
  successLogoutMessage: 'You have been successfully logged out',
};

export default GlobalText;
